import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";
import { formatDate, formatCurrency, formatPaymentMethod } from "../utils/orderDetailsUtils";

const OrderInfoSection = ({ order }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    return (
        <div className="order-info-section">
            <h2>{t('orderInformation')}</h2>
            <div className="info-row">
                <span className="info-label">
                    {order.orderNumber ? t('orderNumber') : t('orderId')}:
                </span>
                <span className="info-value">
                    {order.orderNumber ? `#${order.orderNumber}` : order.id}
                </span>
            </div>
            {order.orderNumber && (
                <div className="info-row">
                    <span className="info-label">{t('orderId')}:</span>
                    <span className="info-value">{order.id}</span>
                </div>
            )}
            <div className="info-row">
                <span className="info-label">{t('date')}:</span>
                <span className="info-value">{formatDate(order.createdAt)}</span>
            </div>
            <div className="info-row">
                <span className="info-label">{t('status')}:</span>
                <span className={`status-badge status-${order.status?.toLowerCase()}`}>
                    {order.status || t('statusPending')}
                </span>
            </div>
            <div className="info-row">
                <span className="info-label">{t('total')}:</span>
                <span className="info-value">
                    {order.currency} {formatCurrency(order.total)}
                </span>
            </div>
            <div className="info-row">
                <span className="info-label">{t('paymentMethod')}:</span>
                <span className="info-value">
                    {formatPaymentMethod(order.paymentMethod, t)}
                </span>
            </div>
            {order.paymentStatus && (
                <div className="info-row">
                    <span className="info-label">{t('paymentStatus')}:</span>
                    <span className="info-value">{order.paymentStatus}</span>
                </div>
            )}

            {order.paymentDetails?.stripePaymentIntentId && (
                <div className="info-row">
                    <span className="info-label">Stripe Payment Intent ID:</span>
                    <span className="info-value">{order.paymentDetails.stripePaymentIntentId}</span>
                </div>
            )}
            {order.paymentReceipt && (
                <div className="info-row">
                    <span className="info-label">{t('paymentReceipt') || 'Payment Receipt'}:</span>
                    <span className="info-value">
                        <a
                            href={order.paymentReceipt}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="receipt-link"
                        >
                            {t('viewReceipt') || 'View Receipt'} 📄
                        </a>
                    </span>
                </div>
            )}
            {order.orderNotes && (
                <div className="info-row">
                    <span className="info-label">Order Notes:</span>
                    <span className="info-value notes">{order.orderNotes}</span>
                </div>
            )}
        </div>
    );
};

export default OrderInfoSection;